window.$ = window.jQuery = require("jquery");
require("form-serializer")
const Hogan = require("hogan.js");
require("bootstrap-datepicker");
require("jquery.spinner");
const { $err } = require("./error-manager");
const { $am } = require("./account-manager");
const { $em } = require("./emailcart-manager");
const { $addressAutofill } = require("./address-autofill");

export function CartManager(orderID, cart) {
    var self = this;
    self.orderID = orderID;
    self.url = window.jrConfig.jrApiUrl + "/cart";
    self.cart = cart || {};
    self.callbacks = [];
    self.optionalPostalCode = [
        218,
        9,
        12,
        16,
        223,
        224,
        30,
        226,
        227,
        228,
        229,
        299,
        231,
        232,
        49,
        233,
        56,
        289,
        61,
        236,
        66,
        318,
        239,
        75,
        79,
        240,
        84,
        87,
        280,
        97,
        244,
        298,
        300,
        110,
        249,
        250,
        120,
        121,
        127,
        305,
        306,
        144,
        152,
        259,
        176,
        177,
        316,
        212,
        163,
        261,
        311,
        264,
        169,
        183,
        187,
        189,
        320,
        319,
        321,
        192,
        322,
        272,
        199,
        203,
        276,
        278
    ];
    if ($("#basket-items-template").length) {
        self.basketItemsTemplate = Hogan.compile($("#basket-items-template").html());
    }
    if ($("#cart-items-template").length) {
        self.cartItemsTemplate = Hogan.compile($("#cart-items-template").html());
    }
    if ($("#cart-totals-template").length) {
        self.cartTotalsTemplate = Hogan.compile($("#cart-totals-template").html());
    }

    // Get the initial cart data!
    self.load = function(callback) {
        $.ajax({
            dataType: "json",
            url: self.url,
            method: "GET",
            success: function(res) {
                self.cart = res;
                if (callback) {
                    callback(res);
                }
            }
        });
    };

    self.refreshCart = function() {
        self.load(self.setCart);
    };

    self.registerCallback = function(f) {
        self.callbacks.push(f);
    };

    self.showBasket = function(ev) {
        if ($(".shopping-cart").is(":visible")) {
            return self.hideBasket(ev);
        } else {
            $(".shopping-cart-background").show();

            if (self.cart && self.cart.orderID) {
                self.renderBasket(self.cart);
                $(".shopping-cart").slideDown(400);
            } else if (self.orderID) {
                self.load(function() {
                    self.renderBasket(self.cart);
                    $(".shopping-cart").slideDown(400);
                });
            } else {
                $(".basket-items-container").html("Your bag is empty");
                $(".nav-cart-total").html("$0.00");
                $(".shopping-cart").slideDown(400);
            }
        }
        ev.preventDefault();
        return false;
    };

    self.hideBasket = function(ev) {
        $(".shopping-cart-background").hide();
        $(".shopping-cart").fadeToggle("fast");
        ev.preventDefault();
        return false;
    };

    self.adjustVisibility = function() {
        if (self.cart && self.cart.itemcount) {
            $(".hide-cart-empty").show();
            $(".show-cart-empty").hide();
        } else {
            $(".hide-cart-empty").hide();
            $(".show-cart-empty").show();
        }
    };

    self.gaEvent = function(action, label, value) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "GAEvent",
            eventCategory: "checkout",
            eventAction: "checkout-" + action,
            eventLabel: "checkout-" + action + "-" + label,
            eventValue: value || ""
        });
    };

    self.renderBasket = function(cart) {
        if (!self.basketItemsTemplate) {
            return;
        }
        var html = self.basketItemsTemplate.render(cart);
        $(".basket-items-container").html(html);
        $(".nav-cart-total").html(cart.subtotalCurrency);
        self.adjustVisibility();

        $(".basket-items-container .giftwrap")
            .unbind()
            .change(function() {
                var orderitemID = $(this)
                    .parents("div[data-orderitemID]")
                    .attr("data-orderitemID");
                self.setItemGiftwrap(orderitemID, $(this).is(":checked") ? "Y" : "N");
            });

        $(".basket-items-container .remove-item")
            .unbind()
            .click(function(ev) {
                var orderitemID = $(this)
                    .parents("div[data-orderitemID]")
                    .attr("data-orderitemID");
                self.removeItem(orderitemID, function(cart) {
                    self.renderBasket(cart);
                });
                ev.preventDefault();
                return false;
            });

        $am.bind();
        $em.bind();
    };

    function reloadEmptyCart(cart) {
        if (!cart.itemcount) {
            window.location.reload();
        }
    }

    self.renderCartItems = function(cart) {
        if (!self.cartItemsTemplate) {
            return;
        }
        var html = self.cartItemsTemplate.render(cart);
        $(".cart-items-container").html(html);
        self.adjustVisibility();

        $(".cart-items-container .remove-item").click(function(ev) {
            var orderitemID = $(this)
                .parents("div[data-orderitemID]")
                .attr("data-orderitemID");
            self.removeItem(orderitemID, reloadEmptyCart);
            ev.preventDefault();
            return false;
        });

        $(".cart-items-container .add-item").click(function(ev) {
            self.purchaseItem(
                $(this).attr("data-prodID"),
                $(this).attr("data-colorcode"),
                $(this).attr("data-stylesize"),
                1,
                reloadEmptyCart);
            ev.preventDefault();
            return false;
        });

        $(".cart-items-container .giftwrap").change(function() {
            var orderitemID = $(this)
                .parents("div[data-orderitemID]")
                .attr("data-orderitemID");
            self.setItemGiftwrap(orderitemID, $(this).is(":checked") ? "Y" : "N");
        });

        $('.cart-items-container [data-trigger="spinner"]')
            .spinner("delay", 200) //delay in ms
            .spinner("changed", function(e, newVal /* oldVal */) {
                var orderitemID = $(this)
                    .parents("div[data-orderitemID]")
                    .attr("data-orderitemID");
                self.setItemQuantity(orderitemID, newVal, reloadEmptyCart);
            });

        $('input[name="qty"]').on("keypress", function(ev) {
            if (ev.which == 13) {
                ev.preventDefault();
                var orderitemID = $(this)
                    .parents("div[data-orderitemID]")
                    .attr("data-orderitemID");
                self.setItemQuantity(orderitemID, $(this).val());
            }
        });

        $am.bind();
        $em.bind();
    };

    self.renderCartTotals = function(cart) {
        if (!self.cartTotalsTemplate) {
            return;
        }
        var html = self.cartTotalsTemplate.render(cart);
        $(".cart-totals-container").html(html);
        self.adjustVisibility();

        $('select[name="shipcountryID"]').val(cart.shipcountryID);
        $('input[name="shipmethodID"][value="' + cart.shipmethodID + '"]').prop("checked", true);

        $(".back-order-fee").hide();
        if (cart.shipcountryID == 1) {
            $(".duties-message").hide();
        } else {
            $(".duties-message").show();
            if (cart.back_order_fee) {
                $(".back-order-fee").show();
            }
        }

        $(".delivery-datepicker").datepicker({});
        $(".delivery-datepicker")
            .datepicker("update", $(".delivery-date").data("scheduled-delivery"))
            .on("changeDate", function() {
                self.setShipMethod(
                    $('input[name="shipmethodID"]:checked').val(),
                    $(this).datepicker("getFormattedDate")
                );
            });

        $('textarea[name="giftwrapmessage"]')
            .on("input", function() {
                $(this).addClass("empty-giftwrapmessage");
            })
            .on("blur", function() {
                var msg = $.trim($('textarea[name="giftwrapmessage"]').val());
                self.setGiftMessage(msg);
                if (msg) {
                    $('textarea[name="giftwrapmessage"]').removeClass("empty-giftwrapmessage");
                }
            });

        $('button[name="giftmessage-add"]').click(function(ev) {
            var msg = $.trim($('textarea[name="giftwrapmessage"]').val());
            self.setGiftMessage(msg);
            if (msg) {
                $('textarea[name="giftwrapmessage"]').removeClass("empty-giftwrapmessage");
            }
            ev.preventDefault();
            return false;
        });

        $('button[name="giftmessage-remove"]').click(function(ev) {
            self.setGiftMessage(null);
            $('textarea[name="giftwrapmessage"]')
                .val("")
                .addClass("empty-giftwrapmessage");
            ev.preventDefault();
            return false;
        });

        $(".enter-promotion").click(function(ev) {
            $(".promotion-prompt").hide();
            $(".promotion-input").show();
            $('input[name="promotion"]').focus();
            ev.preventDefault();
            return false;
        });

        $('button[name="promotion-remove"]').click(function(ev) {
            self.setPromotion(null);
            ev.preventDefault();
            return false;
        });

        $('input[name="promotion"]')
            .on("input propertychange", function() {
                $(".promotion-error").html("");
            })
            .on("keypress", function(ev) {
                if (ev.which == 13) {
                    ev.preventDefault();
                    $('button[name="promotion-add"]')
                        .focus()
                        .click();
                }
            });

        $('button[name="promotion-add"]').click(function() {
            self.setPromotion($('input[name="promotion"]').val(), null, function(err) {
                if (err && err.status == 422) {
                    $err.ajaxError(err, ".promotion-error");
                    return true;
                }
                return false;
            });
        });

        $(".enter-giftcard").click(function(ev) {
            $(".giftcard-prompt").hide();
            $(".giftcard-input").show();
            $('input[name="giftcardname"]').focus();
            ev.preventDefault();
            return false;
        });

        $('button[name="giftcard-remove"]').click(function(ev) {
            self.removeGiftcard();
            ev.preventDefault();
            return false;
        });

        $('input[name="giftcardcode"], input[name="giftcardname"]')
            .on("input propertychange", function() {
                $(".giftcard-error").html("");
            })
            .on("keypress", function(ev) {
                if (ev.which == 13) {
                    ev.preventDefault();
                    $('button[name="giftcard-add"]')
                        .focus()
                        .click();
                }
            });

        $('button[name="giftcard-add"]').click(function() {
            self.addGiftcard(
                $('input[name="giftcardcode"]').val(),
                $('input[name="giftcardname"]').val(),
                null,
                function(err) {
                    if (err && err.status == 422 && err.responseJSON) {
                        $err.ajaxError(err, ".giftcard-error");
                        return true;
                    }
                    return false;
                }
            );
        });

        $('input[name="optin"]').change(function() {
            const val = $('input[name="optin"]:checked').val();
            if (val) {
                self.setOptin(val);
            }
        });

        $('select[name="shipcountryID"]').change(function() {
            self.setShipCountry($(this).val());
        });

        $('input[name="shipmethodID"]').change(function() {
            self.setShipMethod($('input[name="shipmethodID"]:checked').val(), null);
        });
    };

    self.findAddress = function(id) {
        var address = {
            usa: 1,
            countryID: 1
        };
        if (self.cart && self.cart.addresses && self.cart.addresses.data) {
            $.each(self.cart.addresses.data, function(idx, value) {
                if (value.accountaddressID == id) {
                    address = value;
                    return false;
                }
            });
        }
        return address;
    };

    self.accountAddressClickHandler = function(scope) {
        return function() {
            $(scope + " [data-accountaddressid]").removeClass("active");
            $(this).addClass("active");

            var id = $(this).data("accountaddressid");
            $(scope + ' input[name="accountaddressID"]')
                .val(id)
                .trigger("change");

            var address = self.findAddress(id);
            $(scope + ' .address-new input:not([type="checkbox"])').val("");
            $(scope + " .address-new select").val("");
            $.each(address, function(field, value) {
                $(scope + ' .address-new input[name="' + field + '"]').val(value);
                $(scope + ' .address-new select[name="' + field + '"]').val(value);
            });

            if (id) {
                $(scope + " .address-new").hide(400);
            } else {
                $(scope + " .address-new").show(400);
            }
        };
    };

    self.countryChange = function(scope) {
        return function() {
            var countryID = $(scope + ' .address-new select[name="countryID"]').val();
            var zip = "Zip code";
            if (countryID == 1) {
                $(scope + " .address-new .state").show();
                $(scope + " .address-new .province").hide();
                var code = $(scope + ' .address-new input[name="zip"]').val();
                if (code) {
                    $(scope + " .address-new .city-container").show();
                } else {
                    $(scope + " .address-new .city-container").hide();
                }
            } else {
                $(scope + " .address-new .city-container").show();
                $(scope + " .address-new .state").hide();
                $(scope + " .address-new .province").show();
                zip = "Postal code";
            }
            $(scope + " .address-new .zip-label").html(zip);
            $(scope + ' .address-new input[name="zip"]').attr("placeholder", zip);
        };
    };

    self.billToShippingChange = function() {
        var checked = $('input[name="billToShipping"][type="checkbox"]').is(":checked");
        $('input[name="billToShipping"][type="hidden"]').val(checked ? 1 : 0);
        if (checked) {
            self.setBillToShipping(function() {
                $(".bill-address-form").hide(500);
                $(".bill-address-summary").show(500);
            });
        } else {
            $(".bill-address-form").show(500);
            $(".bill-address-summary").hide(500);
        }
    };

    self.scopedAddressForm = function(scope, html, address, addressFormTemplate) {
        $(scope).html(html);

        $(scope + " [data-accountaddressid]").click(self.accountAddressClickHandler(scope));

        html = addressFormTemplate.render(address);
        $(scope + " .address-new").html(html);

        // Select Country + State + Set Zip Label
        $(scope + ' select[name="countryID"]').val(address.countryID);
        $(scope + ' select[name="stateID"]').val(address.stateID);
        self.countryChange(scope)();

        $(scope + ' select[name="countryID"]').change(self.countryChange(scope));

        /*
        $addressAutofill.bindCity(scope + ' input[name="city"]',
            function () {
                return $(scope + ' select[name="countryID"]').val();
            },
            function (ev, suggestion) {
                $(scope + ' input[name="zip"]').val(suggestion.zip);
                if (suggestion.stateID) {
                    $(scope + ' select[name="stateID"]').val(suggestion.stateID);
                } else if (suggestion.state) {
                    $(scope + ' input[name="province"]').val(suggestion.state);
                }
            });
        */

        $addressAutofill.bindZip(
            scope + ' input[name="zip"]',
            function() {
                return $(scope + ' select[name="countryID"]').val();
            },
            function(ev, suggestion) {
                $(scope + " .address-new .city-container").show();
                if (suggestion) {
                    $(scope + ' input[name="city"]').val(suggestion.city);
                    if (suggestion.stateID) {
                        $(scope + ' select[name="stateID"]').val(suggestion.stateID);
                    } else if (suggestion.state) {
                        $(scope + ' input[name="province"]').val(suggestion.state);
                    }
                }
            }
        );
    };

    self.renderAddressForm = function(cart) {
        if (!$("#account-address-template").length || !$("#address-form-template").length) {
            return;
        }

        var accountAddressTemplate = Hogan.compile($("#account-address-template").html());
        var html = accountAddressTemplate.render(cart);

        var addressFormTemplate;
        if ($(".ship-address-form").length) {
            addressFormTemplate = Hogan.compile($("#address-form-template").html());
            self.scopedAddressForm(
                ".ship-address-form",
                html,
                cart.shipaddress,
                addressFormTemplate
            );

            $('.ship-address-form input[name="accountaddressID"]').change(function() {
                var address = self.findAddress($(this).val());
                if (address) {
                    self.setShipCountry(address.countryID);
                }
            });

            $('.ship-address-form .address-new select[name="countryID"]').change(function() {
                self.setShipCountry($(this).val());
            });

            // Auto-select first address
            if (!$('.ship-address-form input[name="accountaddressID"]').val()) {
                $(".ship-address-form [data-accountaddressid]:first").trigger("click");
            }
        }

        if ($(".bill-address-form").length) {
            addressFormTemplate = Hogan.compile($("#billaddress-form-template").html());
            self.scopedAddressForm(
                ".bill-address-form",
                html,
                cart.billaddress,
                addressFormTemplate
            );
        }

        $('input[name="billToShipping"][type="checkbox"]').prop("checked", cart.billToShipping ? true : false);
        self.billToShippingChange();

        $('input[name="billToShipping"][type="checkbox"]').change(self.billToShippingChange);
    };

    self.setCart = function(cart) {
        self.orderID = cart.orderID;
        self.cart = cart;
        $(".menu-item-count").html(self.cart.itemcount);

        // Check if there is any payment required
        if (cart.finaltotal == 0) {
            $('fieldset[name="action-buttons"]').hide();
            $('fieldset[name="giftcard-checkout"]').show();
        } else {
            $('fieldset[name="action-buttons"]').show();
            $('fieldset[name="giftcard-checkout"]').hide();
        }

        if ($(".cart-totals-container").length) {
            // Empty cart, reload page!
            if (cart.orderitems.length == 0) {
                location.href = "/cart";
                return;
            }

            self.renderCartTotals(cart);
        }

        if ($(".cart-items-container").length) {
            self.renderCartItems(cart);
        }

        if ($(".basket-items-container").length) {
            self.renderBasket(cart);
        }

        if ($(".promotion-error-display").length && cart.promotion && !cart.promotion_success) {
            var promotionErrorTemplate = Hogan.compile($("#promotion-error-template").html());
            html = promotionErrorTemplate.render(cart);
            $(".promotion-error-display").html(html);
        }

        var html;
        if ($(".ship-address-summary").length) {
            html = "";
            if (!cart.shipaddress.isEmpty) {
                var shipAddressTemplate = Hogan.compile($("#ship-address-template").html());
                html = shipAddressTemplate.render(cart);
            }
            $(".ship-address-summary").html(html);
        }

        if ($(".bill-address-summary").length) {
            html = "";
            if (!cart.billaddress.isEmpty) {
                var billAddressTemplate = Hogan.compile($("#address-template").html());
                html = billAddressTemplate.render(cart.billaddress);
            }
            $(".bill-address-summary").html(html);
        }

        $.each(self.callbacks, function(idx, f) {
            if (typeof f === "function") {
                f(cart);
            }
        });
    };

    self.waitlist = function(prodID, colorcode, stylesize, email, callback) {
        self.post(
            "waitlist",
            { prodID: prodID, colorcode: colorcode, stylesize: stylesize, email: email },
            function(result) {
                if (callback) {
                    callback(result);
                }
            }
        );
    };

    self.addItem = function(prodID, colorcode, stylesize, qty, accountwishlistID) {
        $(".shopping-cart-background").show();
        $(".menu-bag:visible")[0].scrollIntoView();
        self.post(
            "add-item",
            {
                prodID: prodID,
                colorcode: colorcode,
                stylesize: stylesize,
                qty: qty,
                accountwishlistID: accountwishlistID
            },
            function(cart) {
                self.renderBasket(cart);
                $(".shopping-cart").slideDown(400); // .delay(2500).fadeOut();
                var item = self.findOrderItem(null, parseInt(prodID));
                self.addToCartEvent(item, qty);
            }
        );
    };

    self.purchaseItem = function(prodID, colorcode, stylesize, qty, callback) {
        self.post(
            "add-item",
            { prodID: prodID, colorcode: colorcode, stylesize: stylesize, qty: qty },
            function(cart) {
                self.renderBasket(cart);
                var item = self.findOrderItem(null, parseInt(prodID));
                self.addToCartEvent(item, qty);
                if (callback) {
                    callback(cart);
                }
            }
        );
    };

    self.setItemQuantity = function(orderitemID, qty, success, error) {
        var item = self.findOrderItem(parseInt(orderitemID));
        self.post(
            "set-item-quantity",
            { orderitemID: orderitemID, qty: qty },
            function(cart) {
                if (success) {
                    success(cart);
                }
                if (item) {
                    qty = parseInt(qty);
                    if (qty > item.qty) {
                        self.addToCartEvent(item, qty - item.qty);
                    } else {
                        self.removeFromCartEvent(item, item.qty - qty);
                    }
                }
            },
            error
        );
    };

    self.setItemGiftwrap = function(orderitemID, giftwrap_YN, success, error) {
        self.post(
            "set-item-giftwrap",
            { orderitemID: orderitemID, giftwrap_YN: giftwrap_YN },
            function(cart) {
                if (success) {
                    success(cart);
                }
                self.checkoutOptionEvent(giftwrap_YN == "Y" ? "add giftwrap" : "remove giftwrap");
            },
            error
        );
    };

    self.removeItem = function(orderitemID, success, error) {
        var item = self.findOrderItem(parseInt(orderitemID));
        self.removeFromCartEvent(item); // Post before removal because it may be last item!
        self.post("remove-item", { orderitemID: orderitemID }, success, error);
    };

    self.addGiftcard = function(giftcardcode, giftcardname, success, error) {
        if ($.trim(giftcardcode) || $.trim(giftcardname)) {
            self.post(
                "add-giftcard",
                { giftcardcode: giftcardcode, giftcardname: giftcardname },
                function(cart) {
                    if (success) {
                        success(cart);
                    }
                    self.checkoutOptionEvent("add giftcard: " + giftcardcode);
                },
                error
            );
        } else {
            self.removeGiftcard(success, error);
        }
    };

    self.removeGiftcard = function(success, error) {
        self.post(
            "remove-giftcard",
            {},
            function(cart) {
                if (success) {
                    success(cart);
                }
                self.checkoutOptionEvent("remove giftcard");
            },
            error
        );
    };

    self.setGiftMessage = function(giftwrapmessage, success, error) {
        self.post("set-gift-message", { giftwrapmessage: giftwrapmessage }, success, error);
    };

    self.setOptin = function(optin, success, error) {
        self.post("set-optin", { optin: optin }, success, error);
    };

    self.setPromotion = function(promotion, success, error) {
        self.post(
            "set-promotion",
            { promotion: promotion },
            function(cart) {
                if (success) {
                    success(cart);
                }
                self.checkoutOptionEvent(
                    promotion ? "add promotion: " + promotion : "remove promotion"
                );
            },
            error
        );
    };

    self.setShipCountry = function(shipcountryID, success, error) {
        self.post(
            "set-ship-country",
            { shipcountryID: shipcountryID },
            function(cart) {
                if (success) {
                    success(cart);
                }
                self.checkoutOptionEvent("shipcountry: " + shipcountryID);
            },
            error
        );
    };

    self.setShipCountryCode = function(countrycode, success, error) {
        self.post("set-ship-countrycode", { countrycode: countrycode }, success, error);
    };

    self.setShipMethod = function(shipmethodID, date, success, error) {
        self.post(
            "set-ship-method",
            {
                shipmethodID: shipmethodID,
                scheduled_delivery: date
            },
            function(cart) {
                if (success) {
                    success(cart);
                }
                self.checkoutOptionEvent("shipmethod: " + shipmethodID);
            },
            error
        );
    };

    self.setAddress = function(type, address, success, error) {
        self.post("set-address/" + type, address, success, error);
    };

    self.setAccountAddress = function(type, accountaddressID, billToShipping, success, error) {
        self.post(
            "set-account-address/" + type,
            {
                accountaddressID: accountaddressID,
                billToShipping: billToShipping
            },
            success,
            error
        );
    };

    self.setBillToShipping = function(success, error) {
        self.post("set-bill-to-shipping", {}, success, error);
    };

    self.checkoutOptionEvent = function(option) {
        window.dataLayer = window.dataLayer || [];
        var step = window.dataLayer.length ? window.dataLayer[0]["cartStep"] || 1 : 1;
        window.dataLayer.push({
            event: "checkoutOption",
            ecommerce: {
                checkout_option: {
                    actionField: { step: step, option: option }
                }
            }
        });
    };

    self.addToCartEvent = function(item, qty) {
        if (item) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "addToCart",
                ecommerce: {
                    currencyCode: "USD",
                    add: {
                        products: [self.orderItemToDataLayer(item, qty)]
                    }
                }
            });
            window.dataLayer.push({
                event: "FBEvent",
                facebookEvent: {
                    type: "AddToCart",
                    data: {
                        content_ids: self.orderItemSkus(),
                        content_type: "product",
                        value: self.cart.finaltotal,
                        currency: "USD"
                    }
                }
            });
        }
    };

    self.removeFromCartEvent = function(item, qty) {
        if (item) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "removeFromCart",
                ecommerce: {
                    currencyCode: "USD",
                    remove: {
                        products: [self.orderItemToDataLayer(item, qty)]
                    }
                }
            });
        }
    };

    self.setShippingAddress = function() {
        var changeStep = function() {
            $('[data-step-edit="2"]').hide(500);
            $('[data-step-summary="2"]').show(500);
            $('[data-step="3"]').show(500);
            $("html, body").animate(
                {
                    scrollTop: $("#shippingForm").offset().top
                },
                500
            );
            $('input[name="ccnumber"]').focus();
        };
        // Determine if using saved address
        var id = $('.ship-address-form input[name="accountaddressID"]').val();
        var billToShipping = $('input[name="billToShipping"][type="checkbox"]').is(":checked") ? 1 : 0;
        if (id) {
            self.setAccountAddress("ship", id, billToShipping, changeStep);
        } else {
            var data = $('form[name="shipping"]').serializeObject();
            data.billToShipping = billToShipping;
            self.setAddress("ship", data, changeStep);
        }
    };

    self.orderItemToDataLayer = function(item, qty) {
        return item
            ? {
                  id: item.style,
                  sku: item.sku,
                  name: item.datamann_desc,
                  category: item.category,
                  variant: item.colorcode + " " + item.stylesize,
                  price: item.price,
                  quantity: qty ? qty : item.qty,
                  extendedPrice: item.extended_price
              }
            : {};
    };

    self.findOrderItem = function(orderitemID, prodID) {
        var result = null;
        $.each(self.cart.orderitems.data, function(idx, item) {
            if (item.orderitemID == orderitemID || item.prodID == prodID) {
                result = item;
                return false;
            }
        });
        return result;
    };

    self.orderItemSkus = function(itemRemoved) {
        return $.map(self.cart.orderitems.data, function(item) {
            if (!itemRemoved || itemRemoved.sku != item.sku) {
                if (item.sku) {
                    return item.sku.trim();
                }
            }
        });
    };

    self.post = function(action, data, success, error) {
        $('fieldset[name="action-buttons"]').attr("disabled", "disabled");
        if (self.orderID) {
            action += "/" + self.orderID;
        }
        data = data || {};
        $.ajax({
            dataType: "json",
            url: self.url + "/" + action,
            method: "POST",
            data: data,
            success: function(res) {
                $('fieldset[name="action-buttons"]').removeAttr("disabled");
                if (res) {
                    if (res.orderID) {
                        self.setCart(res);
                    }
                    if (success) {
                        success(res);
                    }
                }
            },
            error: function(err) {
                $('fieldset[name="action-buttons"]').removeAttr("disabled");
                var handled = error ? error(err) : false;
                if (!handled) {
                    if (err && err.status == 404) {
                        window.location.reload();
                    } else {
                        $err.ajaxError(err, ".error-container");
                    }
                }
            }
        });
    };

    jQuery.ready.then(function() {
        $(".menu-bag").click(self.showBasket);
        $(".nav-cart-continue").click(self.hideBasket);
        $(".shopping-cart-background").click(self.hideBasket);
        $("[data-button-position]").click(function() {
            self.gaEvent($(this).data("button-position"), $(this).data("payment"));
        });
    });
}

export const $cm = new CartManager(window.jrConfig.currentOrderId);
